import ministryService from "../../../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: () => {
    return {
      categories: [],
      loading: false,
      working: false,
    };
  },
  getters: {
    categories(state) {
      return state.categories;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
    ngoCategories(state) {
      return state.categories.filter((el) => el.type === "interior");
    },
    guestCategories(state) {
      return state.categories.filter((el) => el.type === "exterior");
    },
    allCategories(state) {
      return state.categories.filter((el) => el.type === "both");
    },
  },
  mutations: {
    setData(state, payload) {
      state.categories = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async fetchCategories({ commit }) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchCategories();
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async editCategory({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        const res = await ministryService.updateCategory(payload);
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        await dispatch("fetchCategories");
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async addCategory({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        const res = await ministryService.addCategory(payload);
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        await dispatch("fetchCategories");
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteCategory({ commit, dispatch }, id) {
      commit("setLoading", true);
      try {
        const res = await ministryService.deleteCategory(id);
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        await dispatch("fetchCategories");
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
